"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HistoryModelChangeType = void 0;
var HistoryModelChangeType;
(function (HistoryModelChangeType) {
    HistoryModelChangeType["CREATE"] = "CREATE";
    HistoryModelChangeType["UPDATE"] = "UPDATE";
    HistoryModelChangeType["DELETE"] = "DELETE";
})(HistoryModelChangeType = exports.HistoryModelChangeType || (exports.HistoryModelChangeType = {}));
